import AboutCapabilityList from "./AboutCapabilityList";
import AboutDifferentiators from "./AboutDifferentiators";

export const AboutCapabilities = () => (
  <>
    <AboutCapabilityList />
    <AboutDifferentiators />
  </>
);

export default AboutCapabilities;
